import Button from "@pathwright/ui/src/components/button/Button"
import { useTranslate } from "@pathwright/ui/src/components/lng/withTranslate"
import Tooltip from "@pathwright/ui/src/components/tooltip/Tooltip"
import styled from "styled-components"
import {
  useCreateDiscussionSubscriptionMutation,
  useDeleteDiscussionSubscriptionMutation
} from "../../../api/generated"
import { usePathwrightContext } from "../../../pathwright/PathwrightContext"
import { useDiscussionPerms } from "../../permissions"
import { getDiscussionContext } from "./utils"

const StyledTooltip = styled(Tooltip)`
  .Tooltip {
    min-width: 140px;
    white-space: normal;
    text-align: left;
  }
`

const DiscussionSubscription = ({ discussion }) => {
  const { t } = useTranslate()
  const pwContext = usePathwrightContext()
  const discussionContext = getDiscussionContext(discussion)
  const discussionPerms = useDiscussionPerms(discussion)

  const [createDiscussionSubscription] =
    useCreateDiscussionSubscriptionMutation({
      variables: {
        context: discussionContext,
        discussion_id: discussion.id
      }
    })

  const [deleteDiscussionSubscription] =
    useDeleteDiscussionSubscriptionMutation({
      variables: {
        context: discussionContext,
        discussion_id: discussion.id
      }
    })

  const handleToggleSubscription = (e) => {
    e.stopPropagation()

    if (discussion.user_is_subscribed) return deleteDiscussionSubscription()
    if (discussionPerms.canSubscribeTo) return createDiscussionSubscription()
  }

  const tooltip = discussion.user_is_subscribed
    ? t("You'll be notified when someone replies to this post.")
    : t("Get notified when someone replies to this post.")
  const icon = discussion.user_is_subscribed ? "bell-fill" : "bell"

  return (
    <StyledTooltip title={tooltip}>
      <Button
        styleType="tertiary"
        onClick={handleToggleSubscription}
        brand={discussion.user_is_subscribed}
        interactive={discussionPerms.canSubscribeTo}
        style={{ padding: ".5em", borderRadius: "8px" }}
        icon={icon}
        size="large"
      />
    </StyledTooltip>
  )
}

DiscussionSubscription.displayName = "DiscussionSubscription"

export default DiscussionSubscription
